import update from 'immutability-helper';
import { LAYOUT as DISCOVER_LAYOUT } from '../constants/discover';
import {
  INIT_DISCOVER,
  GET_LAYOUTID,
  // layouts
  GET_EXPERT_LIST,
  GET_POPULAR_POI,
  GET_POPULAR_ITINERARY,
  GET_FEATURE_LIST,
  GET_POPULAR_JOURNAL,
  GET_LATEST_JOURNAL,
  GET_PRODUCT_LIST,
  GET_PRODUCT_BANNER,
  GET_DISCOVER_TOPIC_01,
  GET_FOLLOWING,
  GET_CITY,
  // end of layouts
  GET_FUTURE_COUNT,
  GET_ACTION_BUTTONS
} from '../actionTypes/discover';

const initState = {
  areaID: '',
  layoutID: {
    loading: false,
    data: []
  },
  expertList: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  latestJournalList: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  popularPoiList: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  popularItineraryList: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  featureList: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  popularJournalList: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  productList: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  following: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  productBanner: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  // topic 經討論後用寫死的方式，所以每新出一個要秀在 discover 上的 topic，就要手動修改對應的 reducer..
  topicCarousel: {
    layoutID: '',
    loading: false,
    data: [],
    dataNext: false
  },
  city: {
    layoutID: '',
    loading: false,
    data: []
  },
  [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: {
    loading: false,
    data: []
  },
  [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: {
    loading: false,
    data: 0
  }
};
const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    case INIT_DISCOVER:
      return initState;
    case GET_LAYOUTID.LOADING: // 每次重取 LAYOUTID 都要清空其他 LAYOUT 資料
      return {
        ...initState,
        layoutID: {
          ...state.layoutID,
          loading: true
        }
      };
    case GET_LAYOUTID.SUCCESS:
      return {
        ...state,
        areaID: action.payload.areaID,
        layoutID: {
          loading: false,
          data: formatObjectKeyOfID(action.payload.data),
          dataNext: false
        }
      };
    case GET_LAYOUTID.FAIL:
      return {
        ...state,
        layoutID: {
          loading: false,
          data: [],
          dataNext: false
        }
      };
    case GET_ACTION_BUTTONS.LOADING:
      return {
        ...state,
        [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: {
          loading: true
        }
      };
    case GET_ACTION_BUTTONS.SUCCESS:
      return {
        ...state,
        [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: {
          loading: false,
          data: action.payload.data
        }
      };
    case GET_ACTION_BUTTONS.FAIL:
      return {
        ...state,
        [DISCOVER_LAYOUT.ACTION_BUTTONS.NAME]: {
          loading: false,
          data: []
        }
      };
    case GET_FUTURE_COUNT.LOADING:
      return {
        ...state,
        [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: {
          loading: true
        }
      };
    case GET_FUTURE_COUNT.SUCCESS:
      return {
        ...state,
        [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: {
          loading: false,
          data: action.payload.data
        }
      };
    case GET_FUTURE_COUNT.FAIL:
      return {
        ...state,
        [DISCOVER_LAYOUT.FUTURE_COUNT.NAME]: {
          loading: false,
          data: []
        }
      };
    case GET_EXPERT_LIST.LOADING:
    case GET_POPULAR_POI.LOADING:
    case GET_POPULAR_ITINERARY.LOADING:
    case GET_FEATURE_LIST.LOADING:
    case GET_POPULAR_JOURNAL.LOADING:
    case GET_LATEST_JOURNAL.LOADING:
    case GET_PRODUCT_LIST.LOADING:
    case GET_PRODUCT_BANNER.LOADING:
    case GET_FOLLOWING.LOADING:
    case GET_DISCOVER_TOPIC_01.LOADING:
    case GET_CITY.LOADING:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          loading: true
        }
      };
    case GET_EXPERT_LIST.SUCCESS:
    case GET_POPULAR_POI.SUCCESS:
    case GET_POPULAR_ITINERARY.SUCCESS:
    case GET_FEATURE_LIST.SUCCESS:
    case GET_POPULAR_JOURNAL.SUCCESS:
    case GET_LATEST_JOURNAL.SUCCESS:
    case GET_PRODUCT_LIST.SUCCESS:
    case GET_PRODUCT_BANNER.SUCCESS:
    case GET_FOLLOWING.SUCCESS:
    case GET_DISCOVER_TOPIC_01.SUCCESS:
    case GET_CITY.SUCCESS:
      return {
        ...state,
        layoutID: {
          ...state.layoutID,
          data: updateObjectKeyOfID(state, action)
        },
        [action.payload.key]: {
          loading: false,
          data: action.payload.data,
          dataNext: action.payload.dataNext,
          layoutID: action.payload.layoutID
        }
      };
    case GET_EXPERT_LIST.FAIL:
    case GET_POPULAR_ITINERARY.FAIL:
    case GET_POPULAR_POI.FAIL:
    case GET_FEATURE_LIST.FAIL:
    case GET_POPULAR_JOURNAL.FAIL:
    case GET_LATEST_JOURNAL.FAIL:
    case GET_PRODUCT_LIST.FAIL:
    case GET_PRODUCT_BANNER.FAIL:
    case GET_FOLLOWING.FAIL:
    case GET_DISCOVER_TOPIC_01.FAIL:
    case GET_CITY.FAIL:
      return {
        ...state,
        [action.payload.key]: {
          loading: false,
          data: [],
          dataNext: false,
          layoutID: ''
        }
      };
    case GET_POPULAR_JOURNAL.NEXT_SUCCESS:
      return {
        ...state,
        layoutID: {
          ...state.layoutID,
          data: updateObjectKeyOfID(state, action)
        },
        [action.payload.key]: {
          ...state[action.payload.key],
          data: state[action.payload.key].data.concat(action.payload.data),
          dataNext: action.payload.dataNext
        }
      };
    case GET_POPULAR_JOURNAL.NEXT_FAIL:
      return {
        ...state,
        [action.payload.key]: {
          loading: false,
          data: [],
          dataNext: false,
          layoutID: ''
        }
      };
    case GET_EXPERT_LIST.SET_LIKE:
    case GET_POPULAR_POI.SET_LIKE:
    case GET_POPULAR_ITINERARY.SET_LIKE:
    case GET_FEATURE_LIST.SET_LIKE:
    case GET_POPULAR_JOURNAL.SET_LIKE:
    case GET_FOLLOWING.SET_LIKE:
    case GET_LATEST_JOURNAL.SET_LIKE:
      return setLayoutDataLike(state, action.payload);

    default:
      return state;
  }
};

const setLayoutDataLike = (state, payload) => {
  const { key, isLike, index } = payload;
  const likeCount = state[key].data[index].like_counts;
  const newState = update(state, {
    [key]: {
      data: {
        [index]: {
          is_like: { $set: isLike },
          like_counts: { $set: isLike ? likeCount + 1 : likeCount - 1 }
        }
      }
    }
  });
  return newState;
};

const formatObjectKeyOfID = data =>
  data.map(item => ({
    id: item.id || '',
    name: item.name || '',
    dataNextToken: item.data_next_token || '',
    category: item.category || '',
    ad: item.ad || null
  }));

/** updateObjectKeyOfID
 * @description 每次取得該 layout 資料後要一併更新 layoutID 內的 layout dataNextToken 已達成下筆取該 layout 區塊資料時能隨機不重複資料目的
 */
const updateObjectKeyOfID = (state, action) => {
  const { data } = state.layoutID;
  const { dataNextToken, layoutID } = action.payload;

  return data.map(item => ({
    id: item.id,
    name: item.name,
    dataNextToken: item.id === layoutID ? dataNextToken : item.dataNextToken,
    category: item.category,
    ad: item.ad || null
  }));
};
